import { AxiosResponse } from "axios";
import { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import org_api from "../../../api/org_api";
import { Breadcrumb, Table, Text } from "../../../component/common";
import PaginationButtons from "../../../component/PaginationButtons";

const ClientTAReport = () => {
  const org_details = JSON.parse(localStorage.getItem("user__details") || "{}");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPost, setTotal] = useState(0);
  const [clientTAReport, setClientTAReport] = useState<
    {
      recruiter_name: string;
      client_name: string;
      total_position: string;
      candidate_profiles: string;
      selected: string;
      rejected: string;
      completed: string;
      yet_to_interview: string;
      cancelled: string;
      no_show: string;
      proxy: string;
    }[]
  >([]);

  const itemsPerPage = 10;
  const paginatedData = useMemo(() => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return clientTAReport.slice(startIndex, endIndex);
  }, [clientTAReport, currentPage, itemsPerPage]);

  useEffect(() => {
    if (clientTAReport.length > 0) {
      const totalItems = clientTAReport.length;
      setTotal(totalItems);
      setTotalPages(Math.ceil(totalItems / itemsPerPage));
    }
  }, [clientTAReport, itemsPerPage]);

  useEffect(() => {
    setCurrentPage(0);
  }, [clientTAReport]);

  useEffect(() => {
    if (org_details.id) {
      fetchClientTAReport(org_details.id);
    }
  }, [org_details.id]);

  const fetchClientTAReport = async (org_id: string) => {
    try {
      const res: AxiosResponse = await org_api.clientTAReport(org_id);
      if (res.data.success) {
        setClientTAReport(res.data.schedule);
      } else {
        toast.error(res.data.msg);
      }
    } catch (error) {
      toast.error("Error fetching client report");
    }
  };

  const getTableData = () => {
    const columns = [
      { label: "Recruiter Name", accessor: "recruiter_name" },
      { label: "Client Name", accessor: "client_name" },
      { label: "Total Positions", accessor: "total_position" },
      { label: "Candidate Profiles", accessor: "candidate_profiles" },
      { label: "Selected", accessor: "selected" },
      { label: "Rejected", accessor: "rejected" },
      { label: "Completed", accessor: "completed" },
      { label: "Yet to Interview", accessor: "yet_to_interview" },
      { label: "Cancelled", accessor: "cancelled" },
      { label: "No Show", accessor: "no_show" },
      { label: "Proxy", accessor: "proxy" },
    ];

    const data = paginatedData.map((x: any, index: number) => ({
      recruiter_name: <Text key={index}>{x.recruiter_name}</Text>,
      client_name: <Text>{x.client_name}</Text>,
      total_position: <Text>{x.total_position}</Text>,
      candidate_profiles: <Text>{x.candidate_profiles}</Text>,
      selected: <Text>{x.selected}</Text>,
      rejected: <Text>{x.rejected}</Text>,
      completed: <Text>{x.completed}</Text>,
      yet_to_interview: <Text>{x.yet_to_interview}</Text>,
      cancelled: <Text>{x.cancelled}</Text>,
      no_show: <Text>{x.no_show}</Text>,
      proxy: <Text>{x.proxy}</Text>,
    }));

    return { columns, data };
  };

  return (
    <div className="space-y-4">
      <Breadcrumb
        items={[
          { text: "Reports", href: "/report_list" },
          { text: "Client TA Report (" + totalPost + ")", isActive: true },
        ]}
      />
      <div>
        <Table
          columns={getTableData().columns}
          data={getTableData().data}
          isStickyHeader
          containerHeight="h-[calc(100vh-200px)]"
        />

        {totalPost > 10 && (
          <div className="mt-3">
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientTAReport;